const testReg = /common-activity\/(customize\/([a-zA-Z0-9_｜-])+\/)?index.html/;

/**
 * 获取当前活动页面特定路径字符串
 * 示例1：https://topic.quickcan.cn/ads/common-activity/customize/demo1/index.html
 * 会返回：common-activity/customize/demo1/index.html
 * 示例2: https://topic.quickcan.cn/ads/common-activity/index.html
 * 会返回：common-activity/index.html
 *
 */
export function getCurrentCommonActivityHtmlString() {
    const pathname = location.pathname;

    const match = pathname.match(testReg);
    if (match) {
        return match[0];
    } else {
        return '';
    }
}

/**
 * 检测字符串是否是活动工厂的html文件字符串
 */
export function testCommonActivityHtmlString(str: string) {
    return testReg.test(str);
}

/**
 * 获取当前活动页面特定路径字符串
 * 示例1：https://topic.quickcan.cn/ads/common-activity/customize/demo1/index.html
 * 会返回：common-activity/customize/demo1/index.html
 * 示例2: https://topic.quickcan.cn/ads/common-activity/index.html
 * 会返回：common-activity/index.html
 *
 */
export function getCommonActivityHtmlString(url: string) {
    const match = url.match(testReg);
    if (match) {
        return match[0];
    } else {
        return '';
    }
}
